import React from "react";
import { devices } from "~/Common/TranslationConstant";
import { HtmlEditor } from "./HtmlEditor";
import { TS } from "~/Services/TS";
import { Language, Persona } from "~/Types/ApiModels";

export function EditTranslationsStep({
    currentLanguageLookups,
    selectedLanguageCodes,
    personaLookups,
    htmlContent,
    deviceSelected,
    languageSelected,
    segmentSelected,
    onChangeDevice,
    onChangeSegment,
    onChangeLanguage,
    editorRef,
    setEditorRef,
}: {
    currentLanguageLookups: Language[];
    selectedLanguageCodes: string[];
    personaLookups: Persona[];
    htmlContent: string;
    deviceSelected: string | undefined;
    languageSelected: string;
    segmentSelected: string | undefined;
    onChangeDevice: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    onChangeSegment: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    onChangeLanguage: (event: React.ChangeEvent<HTMLSelectElement>) => void;
    editorRef: any;
    setEditorRef: (editor: any) => void;
}) {
    return (
        <div className="grid-block">
            <div className="grid-block vertical filter">
                <div className="title-bar whitebg">
                    <span className="left">
                        <span className="inline-label">
                            <label>{TS("Language")} </label>
                            <select onChange={onChangeLanguage} value={languageSelected}>
                                {selectedLanguageCodes.map((languageCode: string) => {
                                    const description =
                                        currentLanguageLookups.find(x => x.languageCode == languageCode)?.description ||
                                        "";
                                    return (
                                        <option key={languageCode} value={languageCode}>
                                            {languageCode} - {description}
                                        </option>
                                    );
                                })}
                            </select>
                        </span>
                        <span className="inline-label">
                            <label>{TS("Customer Segment")}</label>
                            <select onChange={onChangeSegment} value={segmentSelected}>
                                {personaLookups.map(({ id, name }) => (
                                    <option key={id} value={id}>
                                        {name}
                                    </option>
                                ))}
                            </select>
                        </span>
                        <span className="inline-label">
                            <label>{TS("Device")}</label>
                            <select onChange={onChangeDevice} value={deviceSelected}>
                                {devices.map(device => (
                                    <option key={device} value={device}>
                                        {device}
                                    </option>
                                ))}
                            </select>
                        </span>
                    </span>
                </div>
                <div className="grid-block">
                    <div className="ckeditor-container">
                        <HtmlEditor htmlContent={htmlContent} editorRef={editorRef} setEditorRef={setEditorRef} />
                    </div>
                </div>
            </div>
        </div>
    );
}
